import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import styles from './header.module.css';


const ToggleSwitch = () => {
    const { i18n } = useTranslation();
    const [isArabic, setIsArabic] = useState(i18n.language === 'ar');

    const toggleLanguage = () => {
        const newLanguage = isArabic ? 'en' : 'ar';
        i18n.changeLanguage(newLanguage);
        setIsArabic(!isArabic); 
        window.location.reload()
         
        
        localStorage.setItem('i18nextLng', newLanguage);
    };

    
    return (
        <div className={styles.toggleContainer} onClick={toggleLanguage}>
            <Globe size={20} />
            <div className={`${styles.switch} ${isArabic ? styles.active : ''}`}>
                <div className={styles.slider}>
                        <span className={styles.languageText}>{isArabic ? "ع" : "EN"}</span>
                </div>
                <span className={styles.languageLeft}>EN</span>
                <span className={styles.languageRight}>AR</span>
            </div>
           {/*  <span>{isArabic ? 'العربية' : 'English'}</span> */}
        </div>

        



    );
};

export default ToggleSwitch;
